import { effect, EnvironmentProviders, inject, provideAppInitializer } from "@angular/core";
import { DateAdapter } from "@angular/material/core";
import moment from "moment";
import "moment/locale/id";
import { LanguagePreferenceService } from "@core/services/language-preference.service";

/** moment / Material datepicker locale for each UI language. */
const DATE_LOCALES: Record<string, string> = { en: "en", id: "id" };

/**
 * Keeps the Material datepicker and moment's global locale (month and day names) in step with the
 * UI language. `LocalizedDatePipe` and `DatePipe` calls read the language directly.
 */
export function provideDateLocaleSync(): EnvironmentProviders {
    return provideAppInitializer(() => {
        const language = inject(LanguagePreferenceService);
        const dateAdapter = inject(DateAdapter);
        effect(() => {
            const locale = DATE_LOCALES[language.language()] ?? "en";
            dateAdapter.setLocale(locale);
            moment.locale(locale);
        });
    });
}
